<template>
  <div class="animate-pulse">
    <div
      class="h-3 mt-2 bg-shimmer w-24 rounded ms-4 mb-2 md:ms-0 dark:bg-gray-850"
    ></div>
    <div class="bg-white md:border md:rounded p-4 space-y-3 dark:bg-gray-900">
      <div class="flex justify-between w-full">
        <div class="w-36 h-5 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="bg-shimmer rounded h-5 w-16 dark:bg-gray-850"></div>
      </div>
      <div class="flex justify-between w-full">
        <div class="w-24 h-5 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="bg-shimmer rounded h-5 w-10 dark:bg-gray-850"></div>
      </div>
      <div class="flex justify-between w-full">
        <div class="w-40 h-5 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="bg-shimmer rounded h-5 w-10 dark:bg-gray-850"></div>
      </div>
      <div class="flex justify-between w-full">
        <div class="w-24 h-5 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="bg-shimmer rounded h-5 w-16 dark:bg-gray-850"></div>
      </div>
      <div class="flex justify-between w-full">
        <div class="w-16 h-5 bg-shimmer rounded dark:bg-gray-850"></div>
        <div class="bg-shimmer rounded h-5 w-10 dark:bg-gray-850"></div>
      </div>
    </div>
  </div>
</template>
